var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
// components
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import Header from "../../../../components/Header";
import LeadeGeneration from "./components/LeadGeneration";
import Loader from "@frameworks/shared-library/components/Loader";
// redux
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
var LeadGenerationPartner = function (props) {
    //
    var _a;
    var _b = __read(useState(false), 2), loading = _b[0], setLoading = _b[1];
    var _c = useSelector(function (state) { return state.markets.AifPms; }), subCategoryId = _c.subCategoryId, watchListData = _c.watchListData;
    var _d = useSelector(function (state) { return state.markets.leadservice; }), partnerLead = _d.partnerLead, partnerSelectedSlot = _d.partnerSelectedSlot;
    var onClickConfirm = function () {
        var _a, _b;
        setLoading(true);
        var time = (_b = (_a = partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.timeSlot) === null || _a === void 0 ? void 0 : _a.split("-")[1]) !== null && _b !== void 0 ? _b : "";
        var cleanedTime = moment(time, ["h A"]).format("H").trim();
        var time24 = Number(cleanedTime) - 1;
        aifPmsDi.leadservice
            .partnerLead({
            categoryCode: subCategoryId,
            schemeId: watchListData === null || watchListData === void 0 ? void 0 : watchListData.schemeId,
            meetingDate: partnerSelectedSlot.date,
            meetingTime: String(time24 + ":00"),
            meetingType: "Meeting",
        })
            .then(function (response) {
            setLoading(false);
            resetValues();
        })
            .catch(function (error) {
            setLoading(false);
            resetValues();
        });
    };
    var resetValues = function () {
        aifPmsDi.leadservice.updatePartnerSlot({
            timeSlot: "",
            date: "",
        });
    };
    var onClickCancel = function () {
        props.setVisible(false);
        aifPmsDi.leadservice.updatePartnerLead(null);
    };
    var onSideBarClose = function () {
        props.setVisible(false);
        resetValues();
        aifPmsDi.leadservice.updatePartnerLead(null);
    };
    return (React.createElement("div", { className: "position-relative overflow-y-auto" },
        React.createElement(GenericSidebar, { parentClassname: "primary-aif-pms-sidebar-container client-details-container d-flex flex-column", header: React.createElement(Header, { title: "Connect with our expert", subText: "Please provide details below to register interest", titleClassName: "DMSansMedium_20_500 lh-sm mb-1", subTextClassName: "DMSanN_14_300 lh-sm" }), body: loading ? React.createElement(Loader, null) : React.createElement(LeadeGeneration, null), footer: ((_a = partnerLead === null || partnerLead === void 0 ? void 0 : partnerLead.data) === null || _a === void 0 ? void 0 : _a.response) ? (React.createElement("div", { className: "d-flex justify-content-end ", style: { flex: 1 } },
                React.createElement(EdButton, { onClick: onClickCancel, btnTyp: "han-blue-border", value: "Close", className: "rounded-pill DMSanM_16_500 bg-transparent border-blue txt-hanBlue" }))) : (React.createElement("div", { className: "d-flex justify-content-center flex-wrap" },
                React.createElement(EdButton, { onClick: onClickCancel, btnTyp: "link", value: "Cancel", className: "DMSanM_16_500" }),
                React.createElement(EdButton, { onClick: onClickConfirm, btnTyp: "tomato-red", value: "Confirm", className: "partner-proceed rounded-pill DMSanM_16_500 width-180 px-0" }))), openKey: props.visible, arrowClose: true, delay: 10, blurBackground: true, setOpenKey: props.setVisible, parentIcon: "edel-icon-close", onSideBarClose: onSideBarClose })));
};
export default LeadGenerationPartner;
